import React from 'react';
import { CheckIcon } from 'lucide-react';
import { bonuses, builtToHelp } from '../data/toolkit';
export function BonusSection() {
  return <section className="bg-white py-11 sm:py-14" aria-labelledby="bonus-title" data-id="element-10" data-mp="1oflwlkqkz4o8">
      <div className="mx-auto w-full max-w-[42rem] px-4 sm:px-6 lg:max-w-5xl" data-id="element-11" data-mp="22ebv94t1tcep">
        <p className="eyebrow text-[0.66rem] font-semibold text-sand sm:text-[0.72rem]" data-id="element-12" data-mp="1ydrza4k7oeu5">
          Also included at no extra cost
        </p>
        <h2 id="bonus-title" className="mt-3 font-display text-[1.75rem] leading-[1.15] tracking-tight text-navy sm:text-[2.25rem]" data-id="element-13" data-mp="1aop5xzg7sxjt">
          5 practical resources for the work between sessions.
        </h2>

        <ol className="mt-6 grid grid-cols-2 gap-2.5 sm:gap-4 lg:grid-cols-3" data-id="element-14" data-mp="1eqapu4r62c3i">
          {bonuses.map(bonus => <li key={bonus.number} className="flex h-full flex-col rounded-xl border border-navy-line bg-ivory p-4" data-id="element-15" data-mp="qzohsdh5wrti">
              <span className="text-[0.6rem] font-bold uppercase tracking-[0.14em] text-sand" data-id="element-16" data-mp="mx1w6ub3434r">
                Bonus {bonus.number}
              </span>
              <h3 className="mt-1.5 text-[0.88rem] font-semibold leading-snug text-navy sm:text-[0.95rem]" data-id="element-17" data-mp="2epv4x2iqkttm">
                {bonus.title}
              </h3>
              <p className="mt-2 text-[0.79rem] leading-relaxed text-navy-muted sm:text-[0.86rem]" data-id="element-18" data-mp="2ogzgds97dwjp">
                {bonus.description}
              </p>
            </li>)}
          <li className="flex h-full items-center rounded-xl border border-dashed border-teal-mid bg-teal-light p-4" data-id="element-19" data-mp="1qvldh4x043im">
            <p className="text-[0.8rem] font-semibold leading-snug text-teal-deep" data-id="element-20" data-mp="20roe26c7fu3g">
              All 5 bonuses included with OT Clinical Toolkit™
            </p>
          </li>
        </ol>

        <div className="mt-7 border-t border-navy-line pt-6" data-id="element-21" data-mp="3c6k4epk7rjzu">
          <h3 className="text-[0.7rem] font-bold uppercase tracking-[0.16em] text-teal-deep" data-id="element-22" data-mp="3c61w2uka1fbk">
            Built to help you:
          </h3>
          <ul className="mt-3.5 grid gap-2.5 sm:grid-cols-2" data-id="element-23" data-mp="1h3ezphh30v1y">
            {builtToHelp.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-24" data-mp="1c4kiul2odgkh">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-25" data-mp="1c6evlc3sm2dh" />
                <span className="text-[0.92rem] font-medium leading-snug text-navy" data-id="element-26" data-mp="1m28fxhnr705t">
                  {item}
                </span>
              </li>)}
          </ul>
          <p className="mt-5 text-[0.92rem] leading-relaxed text-navy-muted lg:max-w-3xl" data-id="element-27" data-mp="te2uesovl74x">
            Useful across pediatric, adult rehabilitation, school-based,
            outpatient and home-health contexts — whether you are early in your
            career or simply want a more organized clinical workflow.
          </p>
        </div>
      </div>
    </section>;
}